import { useMemo, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useNavigate, useRevalidator } from "react-router-dom";
import { ColDef, GridReadyEvent } from "ag-grid-community";
import { DataGrid } from "../../Controls/DataGrid";
import { PageBar, ToolButton } from "../../Controls/PageBar";
import { DataEntitiesStaff, IntegrationPartyApi, ServerTransferIntegrationParty } from "../../shared/api/axios-client";

import { createApiService } from "../../shared/apiConfig";
import { useAtom } from "jotai";
import { authTokenAtom } from "../../Data/Atoms";
import AdminUsersModal from "./AdminUsersModal";
import { EnvelopePaper } from "react-bootstrap-icons";
import { toast } from "react-toastify";
import { ConfirmDialog } from "../../Controls/ConfirmDialog";

const integrationPartyApi = createApiService(IntegrationPartyApi)
export function AdminIntegrationListPage() {
    const nav = useNavigate();
    const { revalidate } = useRevalidator();
    //const staff = useLoaderData() as Staff[];
    const [showModal, setShowModal] = useState(false);
    const [showEdit, setShowEdit] = useState(false);
    const [item, setItem] = useState<ServerTransferIntegrationParty | undefined>();
    const [items, setItems] = useState<ServerTransferIntegrationParty[]>([]);
    const [authToken, setAuthToken] = useAtom(authTokenAtom);
    const [showConfirm, setShowConfirm] = useState(false);
    const [deleteMessage, setDeleteMessage] = useState("")

    const columns = useMemo<ColDef<DataEntitiesStaff>[]>(() => [

        { field: "staffId", headerName: "#", type: "rightAligned", width: 100 },
        { field: "name", headerName: "Name", width: 200 },
        { field: "emailAddress", headerName: "Email Address", width: 350 },
        { field: "note", headerName: "Note" },
        {
            headerName: "",
            width: 200,
            cellRenderer: ({ data }: { data: DataEntitiesStaff }) => (
                <div className="d-flex gap-1">
                    <button className="btn border-primary border-1 status-btn text-black d-flex-align-center px-2 mt-1  btn btn-sm" onClick={() => onRowClicked(data)}>Edit</button>
                    <button className="btn border-primary border-1 status-btn text-black d-flex-align-center px-2 mt-1  btn btn-sm" onClick={() => deleteClicked(data)}>Delete</button>
                </div>
            )
        }
    ], []);

    const onGridReady = (params: GridReadyEvent) => {
        params.api.sizeColumnsToFit();
    };
    // Place this function definition within the component
    const handleButtonClick = (data: DataEntitiesStaff) => {
        const monitorUrl = process.env.REACT_APP_SPOT_SYNC_MONITOR_TENANT!
        // Implement the action to take when the button is clicked
        const hostname = '';
        const tenantUrl = monitorUrl.replace('_tenant_', hostname);
        const redirectUrl = encodeURIComponent(`/operator/staff`);
        const encodedUrl = `${tenantUrl}/sso?redirectUrl=${redirectUrl}&accessToken=${authToken.accessToken}`;
        window.open(encodedUrl, '_blank');
    };

    const onRowClicked = (data: ServerTransferIntegrationParty) => {
        setItem(data)
        setShowModal(true)
    };
    const deleteClicked = (data: ServerTransferIntegrationParty) => {
        setItem(data)
        setDeleteMessage(`Delete SuperAdmin ${data.name}`)
        setShowConfirm(true)
    };

    const onConfirm = () => {

        integrationPartyApi.deleteIntegrationParty({
            id: item?.id!
        }).then((response) => {
            setShowConfirm(false)
            toast.success('SuperAdmin removed successfully')
            loadItems()
        }).catch(() => {
            toast.error('Cannot complete operation')
        })


        setShowConfirm(false)
    }
    const onHide = () => {
        setShowConfirm(false)
    }
    const onSaveStaff = (data: DataEntitiesStaff, msg: string) => {
        setShowModal(false)
        loadItems();
        toast.success(msg)
    };

    const loadItems = async () => {
        const response = await integrationPartyApi.listIntegrationParty({
            
        })
        if (response.data) {
            setItems(response.data.items!);
        }
    }
    useState(() => {
        loadItems()
    });

    return <Container fluid className="h-100">
        <ConfirmDialog show={showConfirm} onConfirm={onConfirm} title={"Delete SuperAdmin?"} onHide={onHide} message={deleteMessage}>

        </ConfirmDialog>
      
        <Row className="h-100">
            <Col className="h-100" style={{ display: "grid", gridTemplateColumns: "1fr", gridTemplateRows: "max-content 1fr 5px" }}>
                <PageBar title="Super Admins">
                    <ToolButton onClick={() => { setItem(undefined); setShowModal(true) }}>
                        <EnvelopePaper color="maroon" /> Add Super Admin
                    </ToolButton>
                </PageBar>
                <div style={{ height: "100%", width: "100%" }}>
                    <DataGrid
                        rowData={items}
                        columnDefs={columns}
                        onGridReady={onGridReady}
                    />
                </div>
            </Col>
        </Row>
    </Container>;
}